import type { INavigationItem } from '@gig/magic-sdk/dist/adapter/configs/getNavigation';

/**
 * State of the navigation module. Contains all
 * state relating to navigation and routing.
 * @export
 * @interface INavigationState
 */
export interface INavigationState {
    /**
     * The main menu items for the current
     * language and device.
     * @type {INavigationItem[]}
     */
    mainMenu: INavigationItem[];
    /**
     * Whether or not the main menu is loading
     * currently from the back end.
     * @type {boolean}
     */
    mainMenuLoading: boolean;
    /**
     * The current error received from the back end
     * whilst loading the main menu.
     * @type {(string|null)}
     */
    mainMenuError: string | null;

    /**
     * Represents whether the main menu sidebar is open
     * or closed.
     * @type {boolean}
     */
    isMainMenuOpen: boolean;

    /**
     * Represents whether the top navbar is hidden
     * or showing.
     * @type {boolean}
     */
    isSubTopNavHidden: boolean;

    /**
     * The past 15 items of URL history
     * to navigate back through.
     * @type {(string[])}
     */
    previousUrls: string[];
}

export interface INormalizedNavItem {
    icon: string;
    submenu: boolean;
    css: string;
    title: string;
    label: string;
    link: string;
    target: string;
    class: string;
    key: string;
    authenticated: boolean;
}

export const NAVIGATION_NAMESPACE = 'navigation';

export const SET_MAIN_MENU_DATA = 'SET_MAIN_MENU';
export const SET_MAIN_MENU_PENDING = 'SET_MAIN_MENU_PENDING';
export const SET_MAIN_MENU_ERROR = 'SET_MAIN_MENU_ERROR';

export const SET_MAIN_MENU_OPEN = 'SET_MAIN_MENU_OPEN';

export const SET_SUB_TOP_NAV_HIDDEN = 'SET_SUB_TOP_NAV_HIDDEN';

export const ADD_PREVIOUS_URL = 'ADD_PREVIOUS_URL';
